/**
 * <DateCardMobile
 *	/>
 *
 * - When there is a nesting tr, we use tbody as a row.
 *
 * @parent Preview/index.js
 * @stateless
 */
import React, { PropTypes } from 'react';
import classnames from 'classnames';
import moment from 'moment';
import locale from './locale'
import './DateCardMobile.scss';

class DateCardMobile extends React.Component {
  static propTypes = {
    ticket: PropTypes.object.isRequired,
  }

  constructor(props) {
    super(props);
  }

  componentWillMount() {

  }

  render() {
    const {
      title,
      start_at,
      ordered_amount,
    } = this.props.ticket;

    const {show_spots_left} = this.props

    let dateStr = '';
    let timeStr = '';

    if (start_at) {
      dateStr = moment(start_at).format('DD MMMM YYYY, ddd').toUpperCase();
      timeStr = moment(start_at).format('hh:mm A').toUpperCase();
    }

    return (
      <div className='poster-view-date-card-mobile'>
        <div className='col-xs-12'>
          <h5>{title}</h5>
        </div>
        <div className='col-xs-6'>
          <label>{__("Registration Start Time", locale)}</label>
          <h5>
            {dateStr}
          </h5>
          <p>
            <span>{timeStr}</span>
          </p>
        </div>
        {show_spots_left == 1 && <div className='col-xs-6'>
          <label>{__("Total Registered", locale)}</label>
          <h5>
            {__('Total Registered: ', locale)}{ordered_amount || 0}
          </h5>
        </div>}
      </div>
    )
  }
}

export default DateCardMobile;



// WEBPACK FOOTER //
// ./src/shared/PosterView/DateCardMobile.js